import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { SegmentedControlComponent } from './segmented-control/segmented-control.component';
import { ModalOverlayComponent } from './modal-overlay/modal-overlay.component';
import { AudiencePickerComponent } from './audience-picker/audience-picker.component';
import { SpecRowRepeaterComponent } from './spec-row-repeater/spec-row-repeater.component';
import { MemberPickerComponent } from './member-picker/member-picker.component';
import { UnderlineTabsComponent } from './underline-tabs/underline-tabs.component';
import { AudienceBadgeComponent } from './audience-badge/audience-badge.component';
import { ArTagComponent } from './ar-tag/ar-tag.component';
import { IndexStatusPillComponent } from './index-status-pill/index-status-pill.component';
import { DropzoneComponent } from './dropzone/dropzone.component';
import { SequenceRowRepeaterComponent } from './sequence-row-repeater/sequence-row-repeater.component';
import { ShaAlertComponent } from './sha-alert/sha-alert.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { DiscardConfirmComponent } from './discard-confirm/discard-confirm.component';
import { MailboxGateComponent } from './mailbox-gate/mailbox-gate.component';

// SESSION-admin-ptg-002 — shared admin organisms reused across the Products
// catalogue/manage surfaces and the Teams & Groups page (sessions 003 + 004).
// Self-contained module (mirrors AppTopbarModule); consumers import it.
// SESSION-admin-ptg-004 adds MemberPickerComponent.
// SESSION-admin-ptg-003 adds the 6 product-manage atoms/organisms.
@NgModule({
    declarations: [
        SegmentedControlComponent,
        ModalOverlayComponent,
        AudiencePickerComponent,
        SpecRowRepeaterComponent,
        MemberPickerComponent,
        UnderlineTabsComponent,
        AudienceBadgeComponent,
        ArTagComponent,
        IndexStatusPillComponent,
        DropzoneComponent,
        SequenceRowRepeaterComponent,
        // SPEC-webplanner-052 (GAP-WEBPLANNER-068) — SHA presenter alert (S11).
        ShaAlertComponent,
        // SPEC-web-planner-033 AC-10 — the one confirmation dialog (DESIGN-RULES R3).
        ConfirmDialogComponent,
        DiscardConfirmComponent,
        // SPEC-web-planner-038 — the shared "Connect your Gmail" block (invite dialogs + session form).
        MailboxGateComponent,
    ],
    imports: [CommonModule, FormsModule, RouterModule],
    exports: [
        SegmentedControlComponent,
        ModalOverlayComponent,
        AudiencePickerComponent,
        SpecRowRepeaterComponent,
        MemberPickerComponent,
        UnderlineTabsComponent,
        AudienceBadgeComponent,
        ArTagComponent,
        IndexStatusPillComponent,
        DropzoneComponent,
        SequenceRowRepeaterComponent,
        ShaAlertComponent,
        ConfirmDialogComponent,
        DiscardConfirmComponent,
        MailboxGateComponent,
    ],
})
export class AdminUiModule {}
